<div bdFxLayoutAlign="space-between center" class="stepper-container">

    <div *ngIf="selectedIndex > 0" bdFxLayoutAlign="start center" bdFxFlex  >
        <button type="button " class="invisible-button back" [ngClass]="{'disabled' : isNextBtnDisabled}"
                (click)="onPreviousBtnClicked()">
            <i class="fa fa-chevron-left"></i>
            Zurück
        </button>
    </div>
    <div *ngIf="selectedIndex === 0" bdFxFlex></div>

    <div bdFxLayout="row" bdFxLayoutAlign="center center" bdFxFlex class="dots">
        <div *ngFor="let step of _steps; let i = index;" bdFxLayoutAlign="center center" class="dot-container">
            <div bdFxLayoutAlign="center center"
                 class="dot"
                 [ngClass]="{ 'active': selectedIndex === i ,
                              'activated': maxClickableStepIndex >= i ,
                              'invalid': showDotsValidation && maxValidatedStepIndex >= i && stepFormIsInvalid(step) && selectedIndex !== i}"
                 (click)="onStepperDotClicked(i)">
                {{i + 1}}
            </div>
        </div>
    </div>

    <div *ngIf="selectedIndex < _steps.length - 1" bdFxLayoutAlign="end center" bdFxFlex>
        <button type="button " class="invisible-button forward" #nextBtn [ngClass]="{'disabled' : isNextBtnDisabled}"
                (click)="onNextBtnClicked()">
            Weiter
            <i class="fa fa-chevron-right"></i>
        </button>
    </div>
    <div *ngIf="selectedIndex === _steps.length - 1" bdFxFlex></div>

</div>

<ng-container [ngTemplateOutlet]="selected.content"></ng-container>
